module.exports = __webpack_public_path__ + "media/images/gallery/constellations/pn_layer_on-710c957a27cab3b121630886dee5da3d.png";